import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefreshPageWarningComponent } from './refresh-page-warning.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [RefreshPageWarningComponent],
    exports: [RefreshPageWarningComponent]
})
export class RefreshPageWarningModule { }
